/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Course } from './Course';
import { CourseRegistrationLink } from './CourseRegistrationLink';
const ExtendedCourseRegistrationLinkParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['course', Course]]), CourseRegistrationLink);
export class ExtendedCourseRegistrationLink extends CourseRegistrationLink {
    static decode(input) {
        return ExtendedCourseRegistrationLinkParser.decode(input).map(res => new ExtendedCourseRegistrationLink(res));
    }
    static unsafeDecode(input) {
        return ExtendedCourseRegistrationLink.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedCourseRegistrationLinkParser.encode(data);
    }
    static schema() {
        return ExtendedCourseRegistrationLinkParser.schema();
    }
}
